import { MenuTitleType } from "./components/MenuHeader";

export enum MENU_SCREEN {
  Backpacks = "backpacks",
  Jobs = "jobs",
  Home = "home",
  Missions = "missions",
  MoneyPackages = "money-packages",
  Organizations = "organizations",
  Other = "other",
  Profile = "profile",

  Referral = "referral",
  Settings = "settings",
  Shop = "shop",
  Vehicles = "vehicles",
  Vip = "vip",
  Containers = "containers",
  Rules = "rules",
  Haine = "haine",
  Animatii = "animatii",
  Wiki = "wiki",
  Report = "report",
  Vouchers = "vouchers",
}

export type ReferralData = {
  code: string;
};

export type MainMenuContextType = {
  activeScreen: MENU_SCREEN;
  previousScreen?: MENU_SCREEN;

  heading: {
    titleWords: MenuTitleType;
    description: string;
  };

  apoints: number;

  referral?: ReferralData;

  changeScreen: (newScreen: MENU_SCREEN) => void;
  back: () => void;
};
